import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M17 4h-3V2h-4v2H7v18h10V4zm-4 14h-2v-2h2v2zm0-4h-2V9h2v5z"
}), 'BatteryAlertSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BatteryAlertSharp.js
// module id = 2276
// module chunks = 2